// TODO REFACTOR move to ACTION/FOLDER

import PropTypes from 'prop-types';

export const KycPropTypes = {
  status: PropTypes.string.isRequired,
  // validationType: PropTypes.string.isRequired,
  // validationStatus: PropTypes.string.isRequired,
  // approve: PropTypes.bool.isRequired,
  documents: PropTypes.shape({ [PropTypes.string]: PropTypes.any })
};

export const InfoModalStatePropTypes = {
  isOpen: PropTypes.bool.isRequired,
  type: PropTypes.string.isRequired,
  message: PropTypes.string.isRequired,
  callback: {
    fnc: PropTypes.func,
    btnText: PropTypes.string
  }
};

export const defaultInfoModalState = {
  isOpen: false,
  type: 'error',
  message: '',
  callback: {
    fnc: null,
    btnText: null
  }
};
